<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    title="Regional Settings"
  >
    <b-form @submit.prevent="save">
      <b-row>
        <b-col>
          <b-form-group
            label="Currency:"
            >
              <b-form-input
                v-model="currency"
              />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Date:"
            >
              <b-form-input
                v-model="date"
              />
          </b-form-group>
        </b-col>
      </b-row>
      <b-button
        variant="success"
        type="submit"
      >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'

export default {
  data () {
    return {
      currency: null,
      date: null
    }
  },
  computed: {
    ...mapState([
      'dashboardSettings'
    ])
  },
  methods: {
    open () {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    save () {
      db.settings.saveDashboardSettings(
        'regional',
        {
          currency: this.currency || null,
          date: this.date || null
        },
        () => {
          this.$bvToast.toast('Dashboard settings saved.', {
            title: 'Success!',
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 2500,
          })
          this.$nextTick(() => {
            this.setDefaultDashboardSettings()
          })
        }
      )
    },
    setDefaultDashboardSettings () {
      const models = ['currency', 'date']

      for (let model of models) {
        this[model] = this.dashboardSettings.regional[model]
      }
    }
  },
  created () {
    this.setDefaultDashboardSettings()
  }
}
</script>
